import { render, staticRenderFns } from "./CollectionButtons.vue?vue&type=template&id=fb3f6ca0&"
import script from "./CollectionButtons.vue?vue&type=script&lang=js&"
export * from "./CollectionButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports